module.exports = __webpack_public_path__ + "static/acupun_1_xl-608dea165b506a662aaba56e2ed44542.webp";